import React, { useEffect, useState } from "react";
import { makeStyles } from '@mui/styles';
import TextField from '@mui/material/TextField';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs from 'dayjs';

// Define custom styles
const useStyles = makeStyles((theme) => ({
  timePickerInput: {
    
  },
}));

const BasicTimePicker = (props) => {
  // console.log('BasicTimePicker props ', props);
  const [value, setValue] = useState(null);
  const classes = useStyles();

  useEffect(() => {
    if(props && props.scheduledTime && props.scheduledDate){
      let date = new Date(props.scheduledDate * 1000);

      var day = date.getDate();
      var month = date.getMonth();
      var year = date.getFullYear();

      let timeStr = props.scheduledTime;
      let timeArr = timeStr.split(':');
      let hour = timeArr[0];
      let min = timeArr[1];

      let dt = dayjs(year + '-' + month + '-' + day + 'T' + hour + ':' + min);
      if(dt)
        setValue(dt);
    }
    
  }, []);

  const handleChange = (date) => {
    setValue(date);
    props.onChange(date);
  };

  // const formatTimeToString = (time) => {
  //   if (!time) return ''; // Return empty string if no time selected
  //   return time.toLocaleTimeString([], { hour12: false, hour: '2-digit', minute: '2-digit' });
    
  // };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimePicker 
      style = {{height:'35px', width:'130px'}}
      sx={{
        ".MuiOutlinedInput-input":{

          padding:"8px 7px 6px",
          
        },
        ".css-i4bv87-MuiSvgIcon-root":{

          fontSize:"1rem",
          color:"black"
        },
        ".css-3uc1pv-MuiButtonBase-root-MuiIconButton-root":{

          padding:"6px"
        }
      }}
        ampm={false}
        label=""
        value={value}
        onChange={handleChange}
        // onChange={(newValue) => {
        //   setValue(newValue);
        // }}
        renderInput={(params) => (
          <TextField  {...params} InputProps={{ className: classes.timePickerInput }} />
        )}
      />
    </LocalizationProvider>
  );
}

export default BasicTimePicker;

// export default function BasicTimePicker({props}) {
//   console.log('BasicTimePicker props ', props);
//   const classes = useStyles();
//   const [value, setValue] = React.useState(null);

//   useEffect(() => {
//     setValue((props && props.scheduledTime) ? props.scheduledTime : null);
//   }, []);

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs} style = {{height:'35px', width:'130px'}}>
//       <TimePicker style = {{height:'35px', width:'130px'}}
//         ampm={false}
//         label=""
//         value={value}
//         onChange={(newValue) => {
//           setValue(newValue);
//         }}
//         renderInput={(params) => (
//           <TextField  style = {{height:'35px', width:'130px'}} {...params} InputProps={{ className: classes.timePickerInput }} />
//         )}
//       />
//     </LocalizationProvider>
//   );
// }
